module.exports = __webpack_public_path__ + "img/partner.b6af4cf9.png";